
<script>
import Vue from 'vue';

export default {
    props: {
        nodeId: {
            default: () => 0
        }
    },
    data() {
        return {
            establishments: [],
            showAddModal: false,
            filterText: ''
        }
    },
    computed: {
        searchFilteredEstablishments() {
            if(!this.filterText) return this.establishments;
            
            return _.filter(this.establishments, (item) =>
            {
                return _.includes( this.$normalizeString(item.Type), this.filterText )
                    || _.includes( this.$normalizeString(item.EstablishmentId+''), this.filterText )
                    || _.includes( this.$normalizeString(item.EstablishmentName), this.filterText )
                    || _.includes( this.$normalizeString(item.Status), this.filterText );
            });
        }
    },
    mounted: function () {
        this.refresh();
        
        this.$root.$on('pcr_update_data', () => {
            this.refresh();
        });
    },
    methods: {
        currentChange(row) {
            if(this.$getSelectedText()) 
            {
                this.$refs['table'].setCurrentRow();
                return;
            }
            
            this.$router.push({ query: { establishmentId: row.EstablishmentId } });
        }
    },
    watch: {
        nodeId(val) {
            if (val) {
                this.refresh();
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/cross-components/mixins/zone-list.vue